export var TokenType;
(function (TokenType) {
    TokenType["IdToken"] = "id_token";
    TokenType["AccessToken"] = "access_token";
})(TokenType || (TokenType = {}));
//# sourceMappingURL=TokenType.js.map